module.exports = {
    settings: {
        switchPicture: 'Change image',
        closeStore: 'Close store',
        openStore: 'Open store',
        edit: 'Modify store',
        administrator: 'Administrator',
        generalMember: 'Ordinary member',
        admin: 'Administrator',
        general: 'Ordinary member',
        cancel: 'Cancel',
        sure: 'OK',
        queryText: 'Please select a user group',
        store: {
            dialogMsg1: 'Are you sure you want to open your current store?',
            dialogMsg2: 'Are you sure you want to close your current store?'
        },
        storeInfo: {
            dialogTitle: 'Modify store',
            storeName: 'Store name',
            storeId: 'Store number',
            storeAddress: 'Store address',
            cancel: 'Cancel',
            save: 'Save',
            storeIdMsg: 'Please enter the store number',
            storeIdMsg1: 'Please enter a number or letter',
            storeNameMsg: 'Please enter the store name',
            storeAddressMsg: 'Please enter the store address',
            success: 'Modify the store information successfully!',
            fail: 'Failed to modify store information!'
        },
        label: { //标签页选项
            memAndAuth: 'Members and permissions',
            memberManagement: 'Member management',
            userGroupPermissions: 'User group permissions',
        },
        optionPage1: { //成员管理
            addMember: 'Add member',
            allMember: 'All',
            generalMember: 'Ordinary member',
            administrator: 'Administrator',
            table: {
                nickName: 'Member name',
                name: 'Username',
                group: 'User group',
                state: 'Status',
                operation: 'Operation',
                updatde: 'Modify',
                delete: 'Remove',

                generalMember: 'Ordinary member',
                administrator: 'Administrator',
                valid: 'Valid',
                invalid: 'Invalid'
            }
        },
        optionPage2: { //用户组权限
            addGroup: 'Add a user group',
            sure: 'OK',
            cancel: 'Cancel',
            table: {
                operands: 'Object',
                power: 'Permission',
                save: 'Save'
            },
            permissions: {
                permissionType: [{
                    type: 'Product'
                }, {
                    type: 'ESL'
                }, {
                    type: 'Gateway'
                }, {
                    type: 'Template'
                }, {
                    type: 'Interface'
                }, ],
                permissionIndex: ['product', 'label', 'gateway', 'template', 'interface'],
                permission: {
                    product: [{
                        name: '新增商品',
                        whether: false,
                        permissionName: 'Add product'
                    }, {
                        name: '修改商品',
                        whether: false,
                        permissionName: 'Modify product'
                    }, {
                        name: '删除商品',
                        whether: false,
                        permissionName: 'Delete product'
                    }],
                    label: [{
                        name: '新增标签',
                        whether: false,
                        permissionName: 'Add ESL'
                    }, {
                        name: '删除标签',
                        whether: false,
                        permissionName: 'Delete ESL'
                    }, {
                        name: '标签固件升级',
                        whether: false,
                        permissionName: 'Firmware upgrade'
                    }, ],
                    gateway: [{
                        name: '新增网关',
                        whether: false,
                        permissionName: 'Add gateway'
                    }, {
                        name: '修改网关',
                        whether: false,
                        permissionName: 'Modify gateway'
                    }, {
                        name: '删除网关',
                        whether: false,
                        permissionName: 'Delete gateway'
                    }, {
                        name: '网关固件升级',
                        whether: false,
                        permissionName: 'Firmware upgrade'
                    }],
                    template: [{
                        name: '查看模板',
                        whether: false,
                        permissionName: 'View template'
                    }, {
                        name: '新增模板',
                        whether: false,
                        permissionName: 'Add template'
                    }, {
                        name: '修改模板',
                        whether: false,
                        permissionName: 'Modify template'
                    }, {
                        name: '删除模板',
                        whether: false,
                        permissionName: 'Delete template'
                    }],
                    interface: [{
                        name: '思迅接口',
                        whether: false,
                        permissionName: 'Si Xun interface'
                    }, {
                        name: '银豹接口',
                        whether: false,
                        permissionName: 'Yin Bao Interface'
                    }, {
                        name: '云平台',
                        whether: false,
                        permissionName: 'Cloud platform interface'
                    }]
                }
            }
        },
        dialogMsgSetting: {
            cancel: 'Cancel',
            sure: 'OK',
            open: 'Open',
            close: 'Close'
        },
        dialogMsg: {
            cancel: 'Cancel',
            sure: 'OK'
        },
        dialogMsg2: {
            cancel: 'Cancel',
            sure: 'OK'
        },
        validMsg: { //校验提示信息
            memberName: 'Please enter a member name',
            name: 'please enter user name',
            nameValid: 'Please enter a letter or number',
            nameExist: 'User already exists',
            nameFail: 'Failed to get, please re-enter',
            group: 'Please select a user group',
            status: 'Please select a status',
            password: 'Please enter password',
            password2: 'Please enter password again',
            length1: 'Please enter password between 6 and 20 characters',
            length2: 'Please enter a repeat password of 6 to 20 characters',
            passRule: 'User password cannot contain spaces',
            passRule2: 'User password cannot contain Chinese',
            disPw: 'Inconsistent input password twice'
        },
        dialogUpdate: { //修改成员
            dialogTitle: 'Modify',
            nickName: 'Member name',
            name: 'Username',
            group: 'User group',
            state: 'Status',
            cancel: 'Cancel',
            sure: 'OK',
            generalMember: 'Ordinary member',
            administrator: 'Administrator',
            valid: 'Valid',
            invalid: 'Invalid',

            nameTip: 'Please enter a member name',
            success: 'Modify user success!',
            noGroup: 'The user failed to modify, there is no such user group!',
            fail: 'Modify user failed!',
            unUpdate: 'No administrator rights have been modified!'
        },
        dialogAdd: { //添加成员
            dialogTitle: 'Add',
            nickName: 'Member name',
            name: 'Username',
            group: 'User group',
            state: 'Status',
            password: 'Password',
            password2: 'Repeat the password',
            generalMember: 'Ordinary member',
            administrator: 'Administrator',
            valid: 'Valid',
            invalid: 'Invalid',

            nickNameMsg: 'Please enter a member name',
            nameMsg: 'please enter user name',
            groupMsg: 'Please select a user group',
            stateMsg: 'Please select a status',
            passwordMsg: 'Please enter password',
            passwordMsg2: 'Please enter password again',
            cancel: 'Cancel',
            sure: 'OK',

            success: 'Added user success!',
            exist: 'User already exists',
            noGroup: 'The new user failed, there is no such user group!',
            fail: 'Added user failed!'
        },
        queryUser: {
            fail: 'Query current store user failed!'
        },
        queryUserToGroup: {
            fail: 'The user who queried the current user group failed!'
        },
        showRole: {
            admin: 'Administrator',
            general: 'Ordinary member'
        },
        dialogdelete: {
            dialogMsg: 'Are you sure to remove the member {name}?',
            dialogTitle: 'Remove',
            success: 'Remove user success!',
            noPermission: 'No removal permission!',
            fail: 'Failed to remove user!',
            unDelete: 'No admin rights removed!'
        },
        addGroups: {
            superAdministrator: '超级管理员',
            administrator: '管理员',
            generalMember: '普通成员',
            administrator2: '管理者',
            generalMember2: '正会員',
            // admin:'管理员(admin)',
            // general:'普通成员(user)',
            // superAdministrator2:'Super administrator',
            // administrator2:'Administrator',
            // generalMember2:'Ordinary member',
            // admin2:'Administrator(admin)',
            // general2:'Ordinary member(user)',

            success: 'Added user group success!',
            exist: 'This user group already exists!',
            fail: 'Adding a user group failed!',
            // maxLimitNum:"The number of user groups has reached the upper limit",
            inputText: 'Please enter a user group',
            add: 'Add',
            dialogMsg: 'Are you sure to add a new user group {GroupVal}?'
        },
        deleteGroup: {
            dialogMsg: 'Are you sure you want to delete this user group? If you delete the current user group, all members of the group will be reassigned as regular members!',
            dialogTitle: 'Delete',
            success: 'Deleting a user group is successful!',
            fail: 'Deleting a user group failed!'
        },
        getGroup: {
            fail: 'Failed to get all the characters!'
        },
        queryPermission: {
            fail: 'Failed to get permission!'
        },
        updatePermission: {
            update: 'Save',
            dialogMsg: 'Whether to save the current user group permissions!',
            success: 'Modify permission successfully!',
            fail: 'Modify permission failed!'
        },
        hint: {
            // missingRequestParameters:"缺少请求参数",
            openStoreSuccess: "The store opened successfully",
            openStoreFail: "Store opening failed",
            closeStoreSuccess: "The store closed successfully",
            closeStoreFail: "Store closed failed",
            getStoreInfoFail: "Failed to get store information",
            alreadyExistGroup: "This user group already exists",
            changeFail: "Replacement failed",
            internal: "Existing built-in user groups"

            // isNumAndEn:'用户组为纯汉字或纯英文'

        },
        upload: {
            // missingRequestParameters:"缺少请求参数",
            replaceFailed: "Image replacement failed!",
            format: 'Uploading avatar images can only be in JPG and PNG formats!',
            size: 'Image size must be within 370*370!',
            success: 'The picture was replaced successfully!',
            failed: 'Uploading image failed!'
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/en/settings.js